import React from 'react';
import { getDomainById } from '../constants/domains';

/**
 * Colored badge displaying a domain name.
 * Used across all four apps for consistent domain identification.
 */
export default function DomainBadge({ domainId, size = 'sm', className = '' }) {
  const domain = getDomainById(domainId);
  if (!domain) return null;

  const sizeClasses = {
    xs: 'text-xs px-1.5 py-0.5',
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-1.5',
  };

  return (
    <span
      className={`inline-block rounded-full font-medium ${sizeClasses[size]} ${className}`}
      style={{
        backgroundColor: `${domain.color}20`,
        color: domain.color,
        border: `1px solid ${domain.color}40`,
      }}
    >
      {domain.shortName || domain.name}
    </span>
  );
}
